import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import galochka from '../../assets/images/galochka.svg';
import styles from './styles/styles.module.css';

function Switcher({ options, value, onChange, type = 'default' }) {
  const itemsRef = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({});

  useEffect(() => {
    const activeIndex = options.findIndex((opt) => opt.value === value);

    const activeEl = itemsRef.current[activeIndex];
    if (!activeEl) return;

    setIndicatorStyle({
      width: activeEl.offsetWidth,
      left: activeEl.offsetLeft,
    });
  }, [value, options]);

  return (
    <div className={type === 'default' ? styles.wrapper : styles.wrapperPopup}>
      {type === 'default' ? (
        <div className={styles.indicator} style={indicatorStyle} />
      ) : (
        ''
      )}
      {options.map((option, index) => {
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            ref={(el) => {
              itemsRef.current[index] = el;
            }}
            type="button"
            disabled={option.disabled}
            className={`${type === 'default' ? styles.item : styles.itmePopup} 
              ${isActive ? (type === 'default' ? styles.active : styles.activePopup) : ''} 
              ${option.disabled ? styles.disabled : ''}
            `}
            onClick={() => {
              if (!option.disabled) {
                onChange(option.value);
              }
            }}
          >
            {type === 'popup' ? (
              <div className={styles.infoButtons}>
                <img src={option.src} alt="Изоражение способа оплаты" />
                {option.label}
              </div>
            ) : (
              <div>{option.label}</div>
            )}
            {isActive && type === 'popup' ? (
              <img src={galochka} alt="Выбранный вариант оплаты" />
            ) : (
              ''
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Switcher;

Switcher.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: ProcessingInstruction.string,
};
